import React, { useState, useEffect } from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import SpacingBox from "./Spacing";
import HeadingPage from "./Heading";
import AudioPlayer from "./AudioPlayer";
import { useParams } from "react-router-dom";
import useFetchData from "../fetchpostData";
import FillInTheBlanksInput from "./FillInTheBlanksInput";
import Notification from "./Notification";
import ScoreBoxForDoubleAnswer from "./ResponseBoxDoubleType";
import ScoreCardForReading from "./ScoreBoxForReadingSection";
import Timers from "../PageComponent/Timers";
import Timer from "../MockTest/Timer";



export default function FillInTheBlanksListeningPage() {
  const { title } = useParams();
  const section = "fillblank";
  const practiceItemId = title;

  const post = useFetchData(section, title); // Use the hook
  const [originalWords, setOriginalWords] = useState("");
  const [Title, setTitle] = useState("");
  const [audioLink, setaudioLink] = useState("");
  const [Mcq_Question, setMcq_Question] = useState("");
  const [Options, setOptions] = useState([]);

  const [isAttempted, setIsAttempted] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [loading, setLoading] = useState(false);
  const [submittedOptions, setSubmittedOptions] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [savedPractice, setSavedPractice] = useState(null);
  const [userInput, setUserInput] = useState([]);

  useEffect(() => {
    if (post && post.media_link) {
      setOriginalWords(post.question);
      setTitle(post.q_title);
      setOptions(post.option);
      setMcq_Question(post.question_mcq);

        // Extract file name from media_link
        const fileName = encodeURIComponent(post.media_link.split("/").pop());
  
        // Fetch the signed URL from the backend
        fetch(`/ptedata/ptemedia/${fileName}`, { credentials: "include" }) // Ensure cookies/session are sent
          .then((response) => response.json())
          .then((data) => {
            if (data.url) {
             setaudioLink(data.url); // Set the signed URL as the image source
            } else {
              console.error("Failed to fetch image URL");
            }
          })
          .catch((error) => console.error("Error fetching signed URL:", error));
    }
  }, [post]);

  const savePractice = async (practiceData) => {
    try {
      const response = await fetch("/api/save-listeningfillintheblanks", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(practiceData),
      });

      if (!response.ok) {
        throw new Error("Failed to save practice data");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setSubmitted(true);

    const answer = userInput.join(", ");
    const practiceType = section;

    const practiceData = {
      practiceType,
      practiceItemId,
      response: {
        questionId: practiceItemId,
        answer,
        isAttempted,
      },
    };

    try {
      const result = await savePractice(practiceData);
      setMessage("Practice data saved successfully!");
      setNotificationType("success");
      setShowNotification(true);
      setSavedPractice(result);

      setTimeout(() => {
        setIsAttempted(true);
        setLoading(false);
      }, 2000);
    } catch (error) {
      setMessage("Failed to save practice data.");
      setNotificationType("error");
      setShowNotification(true);
      setLoading(false);
      setSubmitted(false);
    }
  };

  const handleRetake = () => {
    setSubmitted(false);
    setIsAttempted(false);
    setSubmittedOptions([]);
  };

  const handleIsAttempted = (isAttemptedValue) => {
    setIsAttempted(isAttemptedValue);
  };

  const handleUserInput = (userInput) => {
    setUserInput(userInput); // Update state with user input
    console.log("User Input:", userInput); // Optional: Log user input for debugging or further processing
  };

  // useEffect to monitor userInput changes
  useEffect(() => {
    console.log("User Input updated:", userInput); // Log whenever userInput changes    
  }, [userInput]);


  const attemptedStatus = isAttempted ? "Attempted" : "Not Attempted";

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <div className="relative md:left-72 left-0 md:ml-3 top-28 bg-gray-100 h-auto w-full md:w-[1150px] rounded-sm p-4 ">
        <HeadingPage
          title={Title}
          timer={<Timers initialSeconds={0} />} // Use the Timer component here
          difficulty="Medium"
          attempted={attemptedStatus}
          para="You will hear a recording. Type the missing words in each blank.
"
        />

        {audioLink && <AudioPlayer audioSrc={audioLink} />}

        <div className="font-bold p-2 pt-4 text-center md:text-right md:ml-[1000px]">  <Timer initialMinutes={10} initialSeconds={0} Text="Time Remaining" /></div>
        <FillInTheBlanksInput
          sentence={originalWords}
          options={Options}
          submitted={submitted}
          onSubmit={handleUserInput} // Pass callback function to receive userInput
          onRetake={handleRetake}
          onIsAttempted={handleIsAttempted}
        />

        <div className="flex space-x-4 mt-4">
          <button
            className="bg-blue-800 hover:bg-blue-500 text-white font-semibold py-1 px-4 ml-5 rounded-sm"
            onClick={handleSubmit}
            disabled={submitted}
          >
            <span className="flex items-center justify-center">
              {loading ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  <span>Submitting...</span>
                </>
              ) : (
                "Submit"
              )}
            </span>
          </button>

          {submitted && (
            <button
              type="button"
              onClick={handleRetake}
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-1 px-4 rounded-sm"
            >
              Retake
            </button>
          )}
        </div>
        {/* {submitted ? (
          <>
            <div className="flex items-center justify-center h-72 bg-gray-100">
              <ScoreCardForReading
                score={savedPractice?.savedResponse.totalScore}
                maxScore={savedPractice?.savedResponse.optionResponses.length}
              />
            </div>
          </>
        ) : null} */}

        <ScoreBoxForDoubleAnswer
          originalWords={originalWords}
          practiceItemId={practiceItemId}
          onIsAttempted={handleIsAttempted}
        />

        <SpacingBox />
      </div>

      {showNotification && (
        <Notification
          message={message}
          type={notificationType}
          onClose={() => setShowNotification(false)}
        />
      )}
    </div>
  );
}
